import { render, staticRenderFns } from "./ReviewProductDropdownField.vue?vue&type=template&id=4b0d3048"
import script from "./ReviewProductDropdownField.vue?vue&type=script&lang=ts"
export * from "./ReviewProductDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0d3048')) {
      api.createRecord('4b0d3048', component.options)
    } else {
      api.reload('4b0d3048', component.options)
    }
    module.hot.accept("./ReviewProductDropdownField.vue?vue&type=template&id=4b0d3048", function () {
      api.rerender('4b0d3048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/ReviewProductDropdownField.vue"
export default component.exports